import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["withDivider", "children", "classes"];
import React from 'react';
import PropTypes from 'prop-types';
import { default as withStyles } from '../styles';
import Typography from '../Typography';
import Divider from '../Divider';
import { spacing50 } from '../styles/tokens';
var styles = {
  root: {
    marginBottom: spacing50
  }
};

/**
 * A component that displays the current step of the total steps
 */
var MobileStepperTitle = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var withDivider = props.withDivider,
    children = props.children,
    classes = props.classes,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  return /*#__PURE__*/React.createElement("div", {
    className: classes.root,
    ref: ref
  }, /*#__PURE__*/React.createElement(Typography, _extends({
    variant: "h2"
  }, rest), children), withDivider && /*#__PURE__*/React.createElement(Divider, null));
});
MobileStepperTitle.propTypes = {
  /**
   * The MobileStepper title value.
   */
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  /**
   * @ignore
   */
  classes: PropTypes.object,
  /**
   * Props will be passed into the rendered `<Typography>` component.
   */
  props: PropTypes.object,
  /**
   * Render the MobileStepperTitle with a divider. Set false to use without a Divider.
   */
  withDivider: PropTypes.bool
};
MobileStepperTitle.defaultProps = {
  withDivider: true
};
MobileStepperTitle.displayName = 'MobileStepperTitle';
export default withStyles(styles)(MobileStepperTitle);